import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {  Paper, Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
const CardsTheme = (props: any) => {
  const { children } = props;
  return <Box className="cardsTheme">{children}</Box>;
};

export default CardsTheme;
